module.exports = __webpack_public_path__ + "static/peoplePC-e51b5945e1016b1edc44b93cc87caa80.png";